import React from "react";
const Modal = ({ showModal, children }) => {
  return <div>{showModal && children}</div>;
};
export default Modal;
